import { Button } from 'antd';
import React from 'react';
import { CloseCircleOutlined } from '@ant-design/icons';
import { TIME_DATATYPE } from 'common/constants/datatypes';
import { formatAsFullDate } from 'common/utils/time';
import { Filter } from '../../../../../../../constants/types';
import { areFiltersEqual } from '../../../../../../../utils/filters';

type SetAttributeFiltersFunction = (attributeFilters: Filter[]) => void

export const removeFilterClick = (
  filter: Filter,
  attributeFilters: Filter[],
  setAttributeFilters: SetAttributeFiltersFunction
) => setAttributeFilters(attributeFilters.filter(attributeFilter => !areFiltersEqual(filter, attributeFilter)));

const removeAttributeFilterButtonStyles = {
  display: 'flex',
  alignItems: 'center',
  marginRight: '10px',
};
export interface Props {
    filter: Filter;
    attributeFilters: Filter[];
    setAttributeFilters: (attributeFilters: Filter[]) => void;
}

const RemoveAttributeFilterButton = ({ filter, attributeFilters, setAttributeFilters }: Props) => (
  <div style={removeAttributeFilterButtonStyles}>
    <Button
      onClick={() => removeFilterClick(filter, attributeFilters, setAttributeFilters)}
      size="large"
    >
      {filter.description} {filter.comparator} {filter.datatype === TIME_DATATYPE ? formatAsFullDate(filter.filteredValues) : filter.filteredValues}{' '}
      <CloseCircleOutlined />
    </Button>
  </div>
);

export default RemoveAttributeFilterButton;
